import { NgxMaskDirective } from 'ngx-mask';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';

import { MatInputModule } from '@angular/material/input';

import { MatIconModule } from '@angular/material/icon';
import { CardTypeComponent } from './card-type.component';
import { UiModule } from '@lockton-apps/shared/ui/lui';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { LetDirective } from '@ngrx/component';
import { CloneDeepPipe } from '@lockton-apps/shared/util/ng-lodash';
import { DynamicFormCellModule } from '../dynamic-form-cell/dynamic-form-cell.module';
import { FieldMetaPipe } from '../pipes/field-meta/field-meta.pipe';
import { FieldOrderPipe } from '../pipes/field-order/field-order.pipe';

@NgModule({
  declarations: [CardTypeComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    NgxMaskDirective,
    FormlyModule.forChild({
      types: [
        {
          name: 'card',
          component: CardTypeComponent,
          wrappers: ['addons'],
        },
      ],
    }),
    UiModule,
    MatIconModule,
    MatCheckboxModule,
    LetDirective,
    CloneDeepPipe,
    DynamicFormCellModule,
    FieldMetaPipe,
    FieldOrderPipe,
  ],
})
export class CardTypeModule {}
